import axios from 'axios';
import store from '../redux/store';
import { logoutUser } from '../redux/actions/authActions';

export const publicUrl = process.env.REACT_APP_BACKEND_URL;

export const instance = axios.create({
  timeout: 30000, // 30 secondes au lieu de 10
  baseURL: `${publicUrl}/api`,
  withCredentials: true,
});

instance.defaults.headers.common.Accept =
  'application/json, application/octet-stream, image/jpeg, image/jpg, image/png, text/plain; application/pdf;';
instance.defaults.headers.common['Content-Type'] = 'application/json, multipart/form-data';

instance.interceptors.request.use(
  (config) => {
        if (isServicePrivate(config.url)) {
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

instance.interceptors.response.use(null, (error) => {
  const originalRequest = error.config;

  if (originalRequest._retry) {
    // Don't call logoutUser() for /me endpoint - let PrivateRoute handle the redirect
    if (originalRequest.url !== "/me") {
      store.dispatch(logoutUser());
    }
    return Promise.reject(error);
  }

  if (error.response && error.response.status === 401
    && error.response.data?.message === "Votre compte n'a pas été vérifié. Veuillez confirmer votre email via l'email envoyé lors de votre inscription.") {
    return Promise.reject(error);
  }

  if (error.response && error.response.status === 401
    && error.response.data?.message === "L'identifiant ou le mot de passe est incorrect. Veuillez réessayer.") {
    return Promise.reject(error);
  }

  if (originalRequest && originalRequest.url !== "/security/token/refresh" && error.response && error.response.status === 401) {
    originalRequest._retry = true;

    return instance.post(`/security/token/refresh`)
    .then((response) => {

      if (response.status === 200) {
        return instance.request(originalRequest);
      }
    })
    .catch((error) => {
      console.log('Refresh token failed:', error);
      // Don't call logoutUser() for /me endpoint - let PrivateRoute handle the redirect
      if (originalRequest.url !== "/me") {
        store.dispatch(logoutUser());
      }
      return Promise.reject(error);
    });
  }

  return Promise.reject(error);
});

const isServicePrivate = (url) => {
  return !(url.match('security')) && !(url.startsWith('/payments/price/home_insurance')) && !(url.startsWith('/forgot_password/'))
}